import { Component } from '@angular/core';

@Component({
  selector: 'app-cancelled-transaction-page',
  imports: [],
  templateUrl: './cancelled-transaction-page.html',
  styleUrl: './cancelled-transaction-page.scss',
})
export class CancelledTransactionPage {
  goBack() {
  window.history.back();
}
}
